<script setup lang="ts">
import { Toaster as Sonner, type ToasterProps } from 'vue-sonner'

const props = defineProps<ToasterProps>()
</script>

<template>
  <Sonner
    class="toaster group flex w-full! items-center justify-center"
    v-bind="props"
    :toast-options="{
      classes: {
        toast:
          'group flex items-center justify-center toast group-[.toaster]:text-foreground group-[.toaster]:border-border',
        description: 'group-[.toast]:text-muted-foreground',
        actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
        cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground'
      }
    }"
  />
</template>
